<template>
  <a :class="{ 'logo--opposite': oppositeColor }" class="logo" href="/">
    <span class="logo__cell logo__cell--1">
      <span class="logo__svg-wrap">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 18 22"
          style="enable-background:new 0 0 18 22;"
          xml:space="preserve"
          class="logo__svg"
          ref="logoSizer"
        >
          <path
            class="logo__path"
            d="M10.1,8.9L7.4,8.4C5.8,8.1,4.5,7.3,4.5,5.8c0-1.9,2.1-2.6,4-2.6c1.9,0,4,0.8,4.4,3.2h3.9C16.6,2.5,13,0,8.7,0C4.9,0,0.5,1.8,0.5,6c0,3.6,2.8,5.3,6.2,6l2.6,0.5c2.2,0.4,3.8,1.1,3.8,2.8c0,2.2-2.3,2.9-4.1,2.9c-2.5,0-4.6-0.9-5-3.9H0c0.4,4.4,3.7,7.2,8.8,7.2c4.2,0,8.4-2.1,8.4-6.3C17.2,10.8,13.5,9.5,10.1,8.9z"
          />
        </svg>
      </span>

      <span class="logo__svg-wrap">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 20 21"
          style="enable-background:new 0 0 20 21;"
          xml:space="preserve"
          class="logo__svg logo__svg--to-edge"
        >
          <path
            class="logo__path"
            d="M5.6,16.5h8l1.5,4.2h4.4L11.8,0H7.7L0,20.7h4.2L5.6,16.5z M9.6,5l2.9,8.2H6.8L9.6,5z"
          />
        </svg>
      </span>
    </span>

    <span class="logo__cell logo__cell--2">
      <span class="logo__svg-wrap">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 26 21"
          style="enable-background:new 0 0 26 21;"
          xml:space="preserve"
          class="logo__svg"
        >
          <polygon
            class="logo__path"
            points="18.1,15.7 14.9,0 10.2,0 7.3,15.6 4.2,0 0,0 4.6,20.7 9.4,20.7 12.5,4.7 15.7,20.7 20.5,20.7 25.1,0 20.9,0 "
          />
        </svg>
      </span>
      <span class="logo__svg-wrap">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 20 21"
          style="enable-background:new 0 0 20 21;"
          xml:space="preserve"
          class="logo__svg logo__svg--to-edge"
        >
          <path
            class="logo__path"
            d="M5.6,16.5h8l1.5,4.2h4.4L11.8,0H7.7L0,20.7h4.2L5.6,16.5z M9.6,5l2.9,8.2H6.8L9.6,5z"
          />
        </svg>
      </span>
    </span>

    <span class="logo__cell logo__cell--3" :style="fluidCellStyles"/>
    <span class="logo__cell logo__cell--3" :style="fluidCellStyles"/>

    <span class="logo__cell logo__cell--4"/>

    <span class="logo__cell logo__cell--5">
      <span class="logo__svg-wrap">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 26 21"
          style="enable-background:new 0 0 26 21;"
          xml:space="preserve"
          class="logo__svg"
        >
          <polygon
            class="logo__path"
            points="18.1,15.7 14.9,0 10.2,0 7.3,15.6 4.2,0 0,0 4.6,20.7 9.4,20.7 12.5,4.7 15.7,20.7 20.5,20.7 25.1,0 20.9,0 "
          />
        </svg>
      </span>
      <span class="logo__svg-wrap">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 20 21"
          style="enable-background:new 0 0 20 21;"
          xml:space="preserve"
          class="logo__svg logo__svg--to-edge"
        >
          <path
            class="logo__path"
            d="M5.6,16.5h8l1.5,4.2h4.4L11.8,0H7.7L0,20.7h4.2L5.6,16.5z M9.6,5l2.9,8.2H6.8L9.6,5z"
          />
        </svg>
      </span>
    </span>
  </a>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  props: {
    oppositeColor: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      cellWidth: 19
    }
  },
  computed: {
    fluidCellStyles () {
      return `
        width: calc(${ this.cellWidth }px + 1em + 1.5px);
        flex-basis: calc(${ this.cellWidth }px + 1em + 1.5px);
      `
    }
  },
  mounted () {
    this.setCellWidth()
    window.addEventListener(
      'resize',
      debounce(this.setCellWidth.bind(this), 200)
    )
  },
  methods: {
    setCellWidth () {
      const { logoSizer } = this.$refs
      this.cellWidth = logoSizer.getBoundingClientRect().width
    }
  }
}
</script>

<style lang="scss" scoped>
  @function logo-border() {
    @return $border-width solid;
  }

  $letter-height: calc(100% - 2 * 0.33em);

  .logo {
    @media (max-width: 300px) {
      display: none;
    }

    @include reset-link;
    @include theme(color);
    display: block;
    overflow: hidden;

    width: 100%;
    height: 100%;
    border: logo-border();
    text-transform: uppercase;

    display: flex;
    flex-wrap: wrap;

    font-size: 14px;

    @include media-down(md) {
      &--opposite {
        color: $main-opposite-color;
      }

      &--opposite &__path {
        fill: $main-opposite-color;
      }
    }

    @include media-up(md) {
      height: calc(100% - 8px); // align to baseline
    }

    @include media-up(md) {
      font-size: 16px;
    }

    @include media-up(md) {
      font-size: 17px;
    }

    &__path {
      @include theme(fill);
    }

    &__svg-wrap {
      display: block;
      position: relative;
      max-height: $letter-height;
      height: $letter-height;
    }

    &__svg {
      max-height: 100%;
      height: 100%;
      display: block;
      position: absolute;
      left: 0;
      top: 0;

      &--to-edge {
        transform: translateX(-100%);
      }
    }

    &__cell {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // height: 50%;
      padding: 0 .5em;

      &--1 {
        @include column-width(calc(50% + #{$border-width / 2}));
        border-right: logo-border();
        border-bottom: logo-border();
      }

      &--2 {
        @include column-width(calc(50% - #{$border-width / 2}));
        border-bottom: logo-border();
      }

      &--3 {
        @include column-width(32px);
        border-right: logo-border();
        transition: width .4s, flex-basis .4s;
        max-width: 40px; // fixes glitch on resize
      }

      &--4 {
        flex: 1;
      }

      &--5 {
        @include column-width(calc(50% + #{$border-width / 2}));
        border-left: logo-border();
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue